<template>
  <i-modal v-model="modal" @on-visible-change="onVisibleChange" title="認証" width="500" footer-hide class="modal-auth">
    <div>
      <template v-if="passwordSet === 1">
        <i-form @submit.native.prevent="onClickLoginModalOk" label-position="top" class="form">
          <i-form-item label="パスワード">
            <i-input type="password" placeholder size="large" v-model="inputPassword" />
            <p class="form__validate">
              <transition name="fade">
                <span v-show="validatePassword !== ''" class="form__validate-text">{{ validatePassword }}</span>
              </transition>
            </p>
          </i-form-item>
        </i-form>
        <div class="btns">
          <i-button @click="onClickLoginModalCancel" style="margin-right: 4px;">キャンセル</i-button>
          <i-button type="primary" @click="onClickLoginModalOk">認証</i-button>
        </div>
      </template>

      <div v-else class="no_data">パスワードが設定されていません。</div>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Button, Form, FormItem, Input } from 'view-design'
import SettingRepository from '@/repositories/settingRepository'
import PropertyDelete from '@/mixins/delete'
export default {
  mixins: [PropertyDelete],
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-input': Input,
  },
  data() {
    return {
      passwordSet: 0,
      inputPassword: '',
      validatePassword: '',
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalAuth/getModal']
      },
      set(val) {
        this.$store.commit('ModalAuth/setModal', val)
      },
    },
    type() {
      return this.$store.getters['ModalAuth/getType']
    },
    item() {
      return this.$store.getters['ModalAuth/getItem']
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    async onVisibleChange(isOpen) {
      if (isOpen) {
        // パスワード設定チェック
        this.checkSetPassword()
      } else {
        setTimeout(this.resetParam, 300)
      }
    },
    // パスワード設定状況取得処理
    checkSetPassword() {
      this.passwordSet = this.$store.getters['User/getUserHasChiefPassword']
    },
    // モーダル キャンセル時の処理
    onClickLoginModalCancel() {
      this.modal = false
    },
    // モーダル 認証ボタン クリック処理
    onClickLoginModalOk() {
      this.validatePassword = ''
      if (this.inputPassword === '') this.validatePassword = 'パスワードを入力してください。'
      if (this.validatePassword !== '') return
      // API ログイン認証
      this.authPassword(this.inputPassword)
    },
    // パスワード認証処理
    async authPassword(password) {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.authPassword(password)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.body.result) {
              this.modal = false
              this.authAfter()
            } else {
              this.validatePassword = resp.data.body.message
            }
          } else if (resp.status === 400) {
            this.validatePassword = resp.data.body.message
          } else {
            alert('パスワード認証に失敗しました。')
            this.modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('パスワード認証に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パスワード認証後の後処理
    authAfter() {
      if (this.type === 'b_delete') {
        // 物件削除
        this.deleteConfirm(this.item.id)
      } else if (this.type === 'all_b_delete') {
        // 一括削除
        this.$store.commit('ModalPropertyBulkDelete/setModal', true)
      }

      this.modal = false
    },
    // モーダル情報をリセットする
    resetParam() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.$store.dispatch('ModalAuth/reset')
      this.passwordSet = 0
      this.inputPassword = ''
      this.validatePassword = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-auth {
  .form {
    min-height: 80px;
    margin-bottom: 0;
    &__validate {
      height: 15px;
      &-text {
        color: #ff0000;
      }
    }
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .no_data {
    margin: 16px 0;
  }
}
</style>
